import { render } from "./staff_profile.vue?vue&type=template&id=75b67050&scoped=true"
import script from "./staff_profile.vue?vue&type=script&lang=js"
export * from "./staff_profile.vue?vue&type=script&lang=js"

import "./staff_profile.vue?vue&type=style&index=0&id=75b67050&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b67050"]])

export default __exports__